import { Result } from "../types";
import { errorResponseBody } from "./response";

export const unauthorized = (error: Error): Result => {
  console.error(error.message, error);

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Content-Type, authorization",
    "Access-Control-Allow-Methods": "GET, OPTIONS",
    "Content-Type": "text/plain",
  };

  return {
    statusCode: 401,
    headers,
    body: errorResponseBody(`401 Unauthorized - ${error.message}`),
  };
};

export const getExternalUserID = (user) => {
  if (user) {
    return (
      user["https://www.vinomofo.com/app_metadata"] &&
      user["https://www.vinomofo.com/app_metadata"][
        `${process.env.GATSBY_VM_MARKET}_EXTERNAL_ID`
      ]
    );
  }
};
